<template>
  <div class="row">
    <div class="col-md-12">
      <form>
        <card>
          <div slot="header">
            <h4 class="card-title">{{ $t("SiUser.Admin_Username_And_Password") }}</h4>
          </div>
          <div>
            <fg-input
              :label="$t('SiUser.Name')"
              required
              v-model="model.name"
              v-validate="modelValidations.name"
              :error="getError('full name')"
              name="full name"
            ></fg-input>

            <fg-input
              :label="$t('SiUser.Email')"
              required
              v-model="model.email"
              v-validate="modelValidations.email"
              :error="getError('email')"
              name="email"
              type="email"
            ></fg-input>

            <fg-input
              :label="$t('SiUser.Password')"
              required
              name="password"
              v-model="model.password"
              v-validate="modelValidations.password"
              :error="getError('password')"
              type="password"
            ></fg-input>
          </div>
          <div class="d-flex justify-content-center">
            <n-button native-type="submit" @click.native.prevent="validate" type="primary">{{ $t('SiUser.Submit_Administrator_Information') }}</n-button>
          </div>
        </card>
      </form>

      <!-- small modal -->
      <modal
        :show.sync="modals.mini"
        class="modal-danger"
        :show-close="false"
        headerClasses="justify-content-center"
        type="mini"
      >
        <div slot="header" class="modal-profile">
          <i class="now-ui-icons ui-1_simple-remove"></i>
        </div>
        <p>
          <strong>{{modals.content}}</strong>
        </p>
        <template slot="footer">
          <!-- <n-button type="neutral" link>Back</n-button> -->
          <n-button type="neutral" link @click.native="modals.mini = false">Close</n-button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Validator } from 'vee-validate';
import { Checkbox, Radio } from "src/components/index";
import { Modal } from "src/components";
// import CryptoJS from "crypto-js";

Validator.extend('passwordCustom', {
  getMessage: `密碼長度應至少8 碼以上，並且混合大小寫英文字母、數字及特殊符號`,
  validate: value => validatePassword(value)
});

function validatePassword(password) {
  if (password && password.length < 8) return false;
  // 條件1: 包含英文字母和數字
  const cond1 = /(?=.*[a-zA-Z])(?=.*\d)/.test(password);
  // 條件2: 包含英文字母大小寫
  const cond2 = /(?=.*[a-z])(?=.*[A-Z])/.test(password);
  // 條件3: 包含符號
  const cond3 = /(?=.*[\W_])/.test(password);

  const passedConditions = [cond1, cond2, cond3].filter(Boolean).length;

  return passedConditions >= 2;
}

export default {
  components: {
    Checkbox,
    Radio,
    Modal
  },
  data() {
    return {
      model: {
        email: "",
        password: "",
        name: ""
      },
      modelValidations: {
        name: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          // min: 8,
          passwordCustom: true
        }
      },
      modals: {
        content: "",
        mini: false
      }
    };
  },
  computed: {
    userType: function() {
      return this.$store.getters.userType;
    }
  },
  mounted() {
    let self = this;
    if (this.$route.params.siUserId) {
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/si/si-users/${this.$route.params.siUserId}`
        )
        .then(response => {
          self.model.email = response.data.email;
          self.model.name = response.data.name;
          return response.data;
        })
        .catch(e => {
          if (e && e.data && e.data.message)
            this.modals.content = e.data.message;

          this.modals.mini = true;
        });
    }
  },
  methods: {
    validate() {
      let self = this;
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);
        if (isValid) {
          if (this.$route.params.siUserId) {
            let putApi = `${process.env.VUE_APP_APIHOST}/si/si-users/${self.$route.params.siUserId}`;
            if (self.userType === 'gaa')
              putApi = `${process.env.VUE_APP_APIHOST}/gaa/si-accounts/${self.$route.params.siId}/si-users/${self.$route.params.siUserId}`
            return axios
              .put(
                putApi,
                {
                  name: this.model.name,
                  email: this.model.email,
                  password: this.model.password
                }
              )
              .then(response => {
                if (response && response.data && response.data.id) {
                  this.$router.push(`/si-accounts/${self.$route.params.siId}/si-users`);
                } else {
                  this.modals.content = $t('SiUser.Message.Create_account_failed');
                  this.modals.mini = true;
                }
                return response.data;
              })
              .catch(e => {
                if (e && e.data && e.data.message)
                  this.modals.content = e.data.message;

                this.modals.mini = true;
              });
          } else {
            let postApi = `${process.env.VUE_APP_APIHOST}/si/si-users`;
            if (this.userType === 'gaa') {
              postApi = `${process.env.VUE_APP_APIHOST}/gaa/si-accounts/${self.$route.params.siId}/si-users`
            }
            return axios
              .post(
                postApi,
                {
                  name: this.model.name,
                  email: this.model.email,
                  password: this.model.password
                }
              )
              .then(response => {
                if (response && response.data && response.data.id) {
                  this.$router.push(`/si-accounts/${self.$route.params.siId}/si-users`);
                } else {
                  this.modals.content = $t('SiUser.Message.Create_account_failed');
                  this.modals.mini = true;
                }
                return response.data;
              })
              .catch(e => {
                if (e && e.data && e.data.message)
                  this.modals.content = e.data.message;

                this.modals.mini = true;
              });
          }
        } else {
          console.log("validate failed");
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    }
  }
};
</script>
<style>
.card .alert {
  position: relative !important;
  width: 100%;
}
</style>